export const translatedTabTitle = (
  providerType: string,
  tabTitle: string
): string => `${providerType}.${tabTitle.toUpperCase()}`;
